export default __webpack_public_path__ + "static/media/retro.ad62c3fe.png";